import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import FormButton from "../../../components/form-button";
import associateServices from "../../../services";
import InputMask from "react-input-mask";
import {toast} from "react-toastify";
import SlimSelect from "slim-select";
import {useSelector} from "react-redux";
import InformationToast from "../../../components/toast/InformationToast";

const Level1 = (props) => {

    const {initial, reFetch} = props
    const {t} = useTranslation()
    const {configuration} = useSelector(state => state.globalReducer);
    const [values, setValues] = useState({
        name: '',
        surname: '',
        birthday: '',
        country_id: '',
        residential: '',
        city: '',
        postal_code: '',
        occupation: '',
        verification_level: '',
    })
    const [loading, setLoading] = useState(false)
    const [completed, setCompleted] = useState(null)
    const [countrySelect, setCountrySelect] = useState(null)
    const [countries, setCountries] = useState([])

    // useEffect(() => {
    //     if (configuration?.country) {
    //         const thec = countries?.find(pp => pp.iso2 === configuration?.country)
    //         if (thec) {
    //             setValues(prevState => ({
    //                 ...prevState,
    //                 country_id: thec?.id
    //             }))
    //             countrySelect?.setSelected([thec.id?.toString()])
    //
    //         }
    //     }
    // }, [configuration?.country, countries, countrySelect])

    useEffect(() => {
        setCompleted(initial.verification_level > 1)
        setValues(initial)

        if (initial.country_id) {
            setValues(prevState => ({
                ...prevState,
                country_id: initial?.country_id
            }))

            countrySelect?.setSelected([initial.country_id?.toString()])
        } else {
            if (configuration?.country) {
                const thec = countries?.find(pp => pp.iso2 === configuration?.country)
                if (thec) {
                    setValues(prevState => ({
                        ...prevState,
                        country_id: thec?.id
                    }))
                    countrySelect?.setSelected([thec.id?.toString()])

                }
            }
        }
    }, [initial, configuration?.country, countries, countrySelect])

    useEffect(() => {
        if (completed === false) {
            associateServices.getCountryList({}).then(res => setCountries(res?.data || []))
        }
    }, [completed])

    useEffect(() => {
        if (countries?.length >= 1 && document.querySelector('#countryList')) {
            setCountrySelect(
                new SlimSelect({
                    select: '#countryList',
                    events: {
                        afterChange: newVal => handleChange('country_id', newVal[0].value)
                    }
                })
            )
        }
    }, [countries])


    const handleChange = (type, value) => setValues(prevState => ({
        ...prevState,
        [type]: value
        // [type]: StringHelper.getStringEN(value?.replace(/[^\w\s]/gi, "")?.replace(/\s/g, ''))
    }))

    const handleUpdate = () => {

        if (!values?.country_id) {
            return toast(<InformationToast
                icon={'ti-x'}
                title={t(`general.error`)}
                message={t(`api-notifications.please-select-your-country`)}
            />)
        }

        setLoading(true)
        associateServices.updateProfile(values).then(res => {
            console.log(res)
            setLoading(false)
            if (res?.status === 200) {
                reFetch()
                return toast.success(t(`api-notifications.${res?.data}`))
            }

            return toast.error(t(`api-notifications.${res?.errors}`))

        })
    }
    return (
        <div className="settings">


            <div className="settings__container">

                <div className="row">
                    <div className="col-12">
                        <p className="settings__text">
                            {t('settings.verify.level1.desc')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="settings__form">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.name')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form__input"
                                        disabled={completed ?? false}
                                        value={values?.name || ''}
                                        onChange={e => handleChange('name', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.surname')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        disabled={completed ?? false}

                                        type="text"
                                        className="form__input"
                                        value={values?.surname || ''}
                                        onChange={e => handleChange('surname', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('general.identity-no')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        disabled={completed ?? false}

                                        type="text"
                                        className="form__input"
                                        value={values?.identity_no || ''}
                                        onChange={e => handleChange('identity_no', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.birthday')}
                                        <b>*</b>
                                    </label>
                                    {/*<input*/}
                                    {/*    value={values?.birthday || ''}*/}
                                    {/*    onChange={e => handleChange('birthday', e.target.value)}*/}
                                    {/*    type="text"*/}
                                    {/*    className="form__input"*/}
                                    {/*/>*/}

                                    <InputMask mask="99-99-9999"
                                               disabled={completed ?? false}

                                               className="form__input"
                                               value={values?.birthday || ''}
                                               onChange={e => handleChange('birthday', e.target.value)}
                                        // onChange={props.onChange} value={props.value}
                                    />

                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.country')}
                                        <b>*</b>
                                    </label>
                                    <select
                                        id="countryList"
                                        className="form__select"
                                        disabled={completed ?? false}

                                        // value={values?.country_id || ''}
                                        // onChange={e => handleChange('country_id', e.target.value)}

                                    >
                                        {
                                            countries?.map(country =>
                                                <option value={country.id} key={country.id}>
                                                    {country.native}
                                                </option>
                                            )
                                        }

                                    </select>
                                </div>
                            </div>


                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.residential')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form__input"
                                        disabled={completed ?? false}
                                        value={values?.residential || ''}
                                        onChange={e => handleChange('residential', e.target.value, false)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.city')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        type="text"
                                        disabled={completed ?? false}
                                        className="form__input"
                                        value={values?.city || ''}
                                        onChange={e => handleChange('city', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.postal-code')}
                                        <b>*</b>
                                    </label>
                                    <input type="text" className="form__input"
                                           disabled={completed ?? false}

                                           value={values?.postal_code || ''}
                                           onChange={e => handleChange('postal_code', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.verify.level1.occupation')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        type="text"
                                        disabled={completed ?? false}
                                        className="form__input"
                                        value={values?.occupation || ''}
                                        onChange={e => handleChange('occupation', e.target.value, false)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="settings__actions">
                <p className="settings__note">
                    {t('settings.verify.level1.footer')}

                </p>
                <div className="settings__btns">
                    <FormButton
                        onClick={handleUpdate}
                        isSmall={true}
                        loading={loading}
                        disabled={completed ?? false}
                        label={t('settings.verify.level1.submit')}
                    />
                </div>
            </div>
        </div>
    )
}
export default Level1
